import "./Email.css";
import { useEmailMessages } from "../../../hooks/useEmailMessages";
import { format } from "date-fns";

function Email() {
  const {
    messages,
    searchInput,
    setSearchInput,
    handleSearchSubmit,
    error,
    isChecked,
    toggleCheckbox,
    individualCheckedState,
    toggleIndividualCheckbox,
    toggleDeleteMessages,
    handleFavoriteToggle,
    handleMessageClick,
    totalMessages,
    currentPage,
    setCurrentPage,
    itemsPerPage,
  } = useEmailMessages();

  return (
    <section id="email" className="homepage-section">
      <form className="email-search-bar" onSubmit={handleSearchSubmit} role="search">
        <button className="search-button-icon" type="submit" aria-label="Search messages">
          <span className="material-symbols-outlined">search</span>
        </button>
        <input
          className="search-input"
          type="search"
          placeholder="Search Mail"
          aria-label="Search mail"
          value={searchInput}
          onChange={(e) => setSearchInput(e.currentTarget.value)}
        ></input>
      </form>
      <div className="email-list-container">
        <div className="email-tools">
          <div>
            <span
              role="checkbox"
              aria-checked={isChecked}
              aria-label="Select all messages"
              tabIndex={0}
              onClick={toggleCheckbox}
              onKeyDown={(e) => e.key === "Enter" && toggleCheckbox()}
              className={`material-symbols-outlined checkbox-icon ${
                isChecked ? "checked" : ""
              }`}
            >
              {isChecked ? "check_box" : "check_box_outline_blank"}
            </span>
            <span
              role="button"
              aria-label="Delete selected messages"
              tabIndex={0}
              onClick={toggleDeleteMessages}
              onKeyDown={(e) => e.key === "Enter" && toggleDeleteMessages()}
              className="material-symbols-outlined"
            >
              delete
            </span>
          </div>
          <div>
            <p>
              {`${currentPage}-${Math.min(
                currentPage * itemsPerPage,
                totalMessages
              )} of ${totalMessages}`}
            </p>
            <div>
              <span
                role="button"
                aria-label="Previous page"
                tabIndex={0}
                className="material-symbols-outlined"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                onKeyDown={(e) => e.key === "Enter" && setCurrentPage((prev) => Math.max(prev - 1, 1))}
              >
                arrow_back_ios
              </span>
              <span
                role="button"
                aria-label="Next page"
                tabIndex={0}
                className="material-symbols-outlined"
                onClick={() =>
                  setCurrentPage((prev) =>
                    Math.min(prev + 1, Math.ceil(totalMessages / itemsPerPage))
                  )
                }
                onKeyDown={(e) =>
                  e.key === "Enter" &&
                  setCurrentPage((prev) =>
                    Math.min(prev + 1, Math.ceil(totalMessages / itemsPerPage))
                  )
                }
              >
                arrow_forward_ios
              </span>
            </div>
          </div>
        </div>
        <div className="email-list-body">
          {error ? (
            <div>{error}</div>
          ) : messages ? (
            messages.map((email) => (
              <div
                key={email.id}
                className={`email-item ${email.is_open ? "open" : "closed"}`}
                onClick={() => handleMessageClick(email.id)}
              >
                <div className="email-icon">
                  <div
                    className="box-checkbox"
                    role="checkbox"
                    aria-checked={!!individualCheckedState[email.id]}
                    aria-label={`Select message: ${email.title}`}
                    tabIndex={0}
                    onClick={(event) => {
                      event.stopPropagation();
                      toggleIndividualCheckbox(email.id);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.stopPropagation();
                        toggleIndividualCheckbox(email.id);
                      }
                    }}
                  >
                    <span
                      className={`material-symbols-outlined ${
                        individualCheckedState[email.id] ? "checked" : ""
                      }`}
                    >
                      {individualCheckedState[email.id]
                        ? "check_box"
                        : "check_box_outline_blank"}
                    </span>
                  </div>
                  <div
                    className="star-checkbox"
                    role="button"
                    aria-label={`${email.is_favorite ? "Unfavorite" : "Favorite"} message: ${email.title}`}
                    tabIndex={0}
                    onClick={(event) => {
                      event.stopPropagation();
                      handleFavoriteToggle(email.id);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.stopPropagation();
                        handleFavoriteToggle(email.id);
                      }
                    }}
                  >
                    <span
                      className={`material-symbols-outlined checkbox-icon ${
                        email.is_favorite ? "checked" : ""
                      }`}
                    >
                      {email.is_favorite ? "star_rate_half" : "star"}
                    </span>
                  </div>
                </div>
                <div className="email-content">
                  <p>{email.title}</p>
                  <p>{email.message}</p>
                  <p>{format(new Date(email.created_at), "MM-dd-yyyy")}</p>
                </div>
              </div>
            ))
          ) : (
            <div>No Emails To Display</div>
          )}
        </div>
      </div>
    </section>
  );
}

export default Email;
